import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBurst: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconBurst"><Path d="M12 1.75V4.24M12 19.75V22.25M1.75 12H4.25M19.75 12H22.25M4.75 4.75L7.5 7.5M16.5 16.5L19.25 19.25M4.75 19.25L7.5 16.5M16.5 7.5L19.25 4.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/></CentralIconBase>;
});

export default IconBurst;
